
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#FF6F4F","stroke-width":"2","stroke-miterlimit":"10"}},[_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M20 16.927a8 8 0 100-16 8 8 0 000 16zM2 39.073a18 18 0 0123-17.291"}})]),_c('path',{attrs:{"d":"M29.807 38.793a9.193 9.193 0 100-18.386 9.193 9.193 0 000 18.386zM26.5 33.19l6.7-6.69M33.2 33.19l-6.7-6.69"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h40v40H0z"}})])])])
          )
        }
      }
    